import { Button, FormTitle, Wrapper, useBreadcrumbRoutes } from '@maxtropy/components';
import { apiV2PowerDispatchOverviewPost } from '@maxtropy/dmes-apis-v2';
import { useRequest } from 'ahooks';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import DevicePowerStatus from './components/DevicePowerStatus';
import DispatchInstruction from './components/DispatchInstruction';
import KeyMetricsMonitor from './components/KeyMetricsMonitor';
import styles from './index.module.scss';

const LoadDispatchCenter = () => {
  const routesContext = useBreadcrumbRoutes();
  const [currentTime, setCurrentTime] = useState(dayjs());
  const { data: overviewData } = useRequest(() => apiV2PowerDispatchOverviewPost({}));
  const maintenanceText =
    overviewData?.maintenance == null ? '--' : overviewData.maintenance ? '检修期间' : '非检修期间';

  useEffect(() => {
    const timer = window.setInterval(() => setCurrentTime(dayjs()), 1000);
    return () => window.clearInterval(timer);
  }, []);

  return (
    <Wrapper routes={[...(routesContext?.routes ?? [])]} hasPadding={false}>
      <main className={styles.page}>
        <FormTitle
          className={styles.pageHeader}
          title="负荷调度中心"
          extraContent={
            <div className={styles.headerActions}>
              <div className={styles.statusInfo}>
                <span>{currentTime.format('YYYY年M月D日 HH:mm:ss')}</span>
                <strong>{maintenanceText}</strong>
              </div>
              <div className={styles.strategyControls}>
                <span>策略控制状态:</span>
                <div
                  className={`${styles.modeButton} ${
                    overviewData?.targetSystem === 'integration' ? styles.activeModeButton : ''
                  }`}
                >
                  <span className={styles.modeButtonText}>自动控制</span>
                  <div className={styles.bottomLine} />
                </div>
                <div
                  className={`${styles.modeButton} ${
                    overviewData?.targetSystem === 'dongfang' ? styles.activeModeButton : ''
                  }`}
                >
                  <span className={styles.modeButtonText}>东方电子接管模式</span>
                  <div className={styles.bottomLine} />
                </div>
              </div>
              <Button type="primary" href="/dispatch/control/load-center/mode-config" target="_blank" rel="noreferrer">
                调控模式配置
              </Button>
            </div>
          }
        />

        <div className={styles.contentPanel}>
          <div className={styles.overviewGrid}>
            <KeyMetricsMonitor />
            <DevicePowerStatus />
          </div>

          <DispatchInstruction />
        </div>
      </main>
    </Wrapper>
  );
};

export default LoadDispatchCenter;
